import React from "react";
import { Box, Skeleton, Typography } from "@mui/material";
import CustomDataGrid from "../../../components/Global/CustomDatagrid/CustomDatagrid";

const HistorySection = ({ isLoading, rows, columns, onRowDoubleClick }) => (
  <Box sx={{ padding: "0 10px" }}>
    <Typography variant="h5" sx={{ mb: 2 }}>
      Historial
    </Typography>
    {isLoading ? (
      <Skeleton variant="rectangular" height={300} sx={{ borderRadius: 2 }} />
    ) : (
      <CustomDataGrid
        rows={(rows || []).slice().reverse()}
        columns={columns}
        getRowId={(row) => row.id}
        onRowDoubleClick={onRowDoubleClick}
      />
    )}
  </Box>
);

export default HistorySection;
